import React, { createContext, useState, useMemo, useEffect } from "react";
import { ContentPermission, OrgPermission } from "@/interfaces/permissions";

const ListContextInitialState: any = {
   listId: '',
   listTile:'',
   setListId: (menuId: string) => {}, 
   appGuid: '',
   setAppGuid: (appguid: string) => {},
   appId: '',
   setAppId: (appId: string) => {},
   orgPermission: undefined,
   setOrgPermission: (orgPermission: OrgPermission) => {},
   listContentPermission: undefined,
   setListContentPermission: (contentPermission: ContentPermission) => {},
   isMainMenu: false,
   listExistsInMultiplePlaces: false,
   setListExistsInMultiplePlaces: (existsElsewhere: boolean) => {},
}   

export const ListContext = createContext(ListContextInitialState);

export default ({ isMainMenu, children }:{ isMainMenu: boolean, children:React.ReactNode}) => {

    const [listId, setListId] = useState<string>('');
    const [appGuid, setAppGuid] = useState<string>('');
    const [appId, setAppId] = useState<string>('');
    const [listTitle, setListTitle] = useState<string>((document?.querySelector('#Title') as HTMLInputElement)?.value);
    const [listExistsInMultiplePlaces, setListExistsInMultiplePlaces] = useState<boolean>(false);
    const [orgPermission, setOrgPermission] = useState<OrgPermission | undefined>(undefined);
    const [listContentPermission, setListContentPermission] = useState<ContentPermission | undefined>(undefined)
    const [isCombinedFeedEnabled, setIsCombinedFeedEnabled] = useState<boolean>(false);
    const listIdObserver = new MutationObserver((mutation: any[]) => setListId(mutation[0].target.value)); 
    
    useEffect(() => {
        /* hidden read only id field exists on page, because its read only we cannot bind an on change event like you would expect, so we have to use a mutation observer
          this will update when a content id is set on save or save and publish
        */
        if(document.querySelector('#Id')) {
          listIdObserver.observe(document?.querySelector?.('#Id') as HTMLElement, {attributes: true, childList: true})
        }
      }, []);

    useEffect(() => {
        const titleInput = document.querySelector('#Title') as HTMLInputElement;
        if (!titleInput) return;

        const handleChange = () => {
            setListTitle(titleInput.value);
        };
        titleInput.addEventListener('input', handleChange);

        return () => {
            titleInput.removeEventListener('input', handleChange);
        };
    }, []);
   

    const context = useMemo(() => ({
        listId,
        setListId,
        appGuid,
        setAppGuid,
        hasEditorRights: (orgPermission === OrgPermission.manage || listContentPermission === ContentPermission.edit),
        listTitle,
        appId,
        setAppId,
        isMainMenu,
        setOrgPermission,
        orgPermission,
        setListContentPermission,
        listContentPermission,
        listExistsInMultiplePlaces,
        setListExistsInMultiplePlaces,
        isCombinedFeedEnabled,
        setIsCombinedFeedEnabled
    }), [listId, appGuid, orgPermission, listContentPermission, listTitle, isMainMenu, isCombinedFeedEnabled])

    return (
        <ListContext.Provider value={context}>
            {children}
        </ListContext.Provider>
    )
}